module.exports = __webpack_public_path__ + "img/00028.7f84807c.webp";